import { Controller } from '@hotwired/stimulus'
import FormCache from '../utils/form_cache'
import { montarSugestao, limparSugestoesEmails } from '../helpers/sugestoes_email_helpers'
import axios from "axios"
import Swal from "sweetalert2"
import Fuse from 'fuse.js'

const dominios = ['gmail.com', 'outlook.com', 'hotmail.com', 'uol.com', 'yahoo.com', 'icloud.com', 'live.com', 'uol.com.br', 'msn.com']

const fuse = new Fuse(dominios)

export default class extends Controller {

  static targets = ['aplicarCache', 'divInputsUtilizadores', 'selectPais', 'selectEstado', 'inputEmail']

  connect() {
    this.montarSelectPais();
    this.monitorarPreenchimento();
    this._adicionarEventos();
    this._fazerCache();
    this._lidarComCollectionsVindasDoJS();
  }

  _adicionarEventos = () => {
    this.selectPaisTargets.forEach((target) => {
      $(target).on('change', (event, estadoAtual) => {
        this.mudouPais(event.currentTarget.value, event.currentTarget.getAttribute("data-identificador-estado"), estadoAtual)
      })
    })

    this.inputEmailTargets.forEach((target) => {
      $(target).on('input', (event) => {
        this.verificarSugestaoEmail(event)
      })
    })
  }

  _fazerCache = () => {
    this.formCache = new FormCache({
      formSeletor: 'form',
      storageName: this.data.get("formCacheStorageName") || 'cacheUtilizadores',
      parentClassToAdd: 'filled',
      alternativeValueAttribute: 'formCacheAltValue'
    });
  }

  aplicarCacheAction = () => {
    if (this.aplicarCacheTarget.checked) {
      this.formCache.fill();
      this._atualizarOpcoesDeDocumento();
      this._atualizarOpcoesDeNome();
      this.formCache.fill();
    } else {
      this.formCache.resetForm()

      this.selectPaisTargets.forEach((paisTarget) => {
        this.LimparEpopularTodosEstadosSelect(paisTarget)
      })
    }
  }

  LimparEpopularTodosEstadosSelect = async (selectPaisTarget) => {
    try {
      if (selectPaisTarget.value) {
        let estadoId = selectPaisTarget.getAttribute('data-identificador-estado')
        let estadoTarguet = this.selectEstadoTargets.filter(estadoTarguet => estadoTarguet.getAttribute('data-id') == estadoId)[0]

        if (!estadoTarguet) return;

        const response = await axios.get(`${this.selectPaisTarget.getAttribute('data-url-get-paises')}/${selectPaisTarget.value}.json`)
        const estados = response.data.estados

        //deve haver novos estados para eu montar o select
        if (estados.length > 0) {
          // remover os antigos
          this.limparFilhos(estadoTarguet)

          //default
          var optionDefault = document.createElement('option')
          optionDefault.value = ''
          optionDefault.innerHTML = ""
          estadoTarguet.append(optionDefault)

          // adicionando novos
          estados.map((estado) => {
            let option = document.createElement('option')

            option.innerHTML = estado.nome
            option.value = estado.sigla

            estadoTarguet.append(option)
          })
        } else {
          console.error('Erro ao LimparEpopularTodosEstadosSelect', response)
        }
      } else {
        this.limparFilhos(selectEstados)

        var optionDefault = document.createElement('option')
        optionDefault.value = ''
        optionDefault.innerHTML = "Selecione um país primeiro"
        selectEstados.append(optionDefault)
      }
    } catch (error) {
      console.error('Erro ao LimparEpopularTodosEstadosSelect 2', error)
      Swal.fire({
        title: I18n.t('mensagem_requisicao_falha_estado'),
        text: I18n.t('erro_entre_contato'),
        icon: 'error',
        showCancelButton: false,
        confirmButtonText: I18n.t('tentar_novamente'),
      }).then((result) => {
        location.reload()
      })
    }
  }

  /** Monitora o preenchimento dos campos de nome e e-mail para saber se título do ingresso deve ou não ficar azul  */
  monitorarPreenchimento = () => {
    let container = this.divInputsUtilizadoresTarget;

    $(container).find('input.utilizador_nome, input.utilizador_email').on('input', (event) => {
      this.verificarSeUtilizadorFoiPreenchido(event.target);
    })

    $(container).find('input.utilizador_nome, input.utilizador_email').each((index, element) => {
      this.verificarSeUtilizadorFoiPreenchido(element);
    })
  }

  paisDefault = (selectbox) => {
    const paisDoComprador = selectbox.getAttribute("data-pais-comprador")
    const utilizadorPaisJaPreenchido = selectbox.getAttribute("data-utilizador-pais")

    return utilizadorPaisJaPreenchido || paisDoComprador
  }

  montarSelectPais = async () => {
    if (this.selectPaisTargets <= 0) return
    try {
      const response = await axios.get(`${this.selectPaisTarget.getAttribute('data-url-get-paises')}.json`)
      const paises = response.data
      let p;

      for (p = 0; p < this.selectPaisTargets.length; p++) {
        let selectbox = this.selectPaisTargets[p];

        const paisDefault = this.paisDefault(selectbox)
        const utilizadorEstadoJaPreenchido = selectbox.getAttribute("data-utilizador-estado")

        //optgroup
        for (var i = 0; i < paises.length; i++) {
          const value = paises[i]
          var optionGroup = document.createElement('OPTGROUP')

          optionGroup.label = value[0]
          selectbox.append(optionGroup)

          //options
          for (var j = 0; j < value[1].length; j++) {
            const pais = value[1][j]
            var option = document.createElement('option')

            //deixar selecionado o pais, caso tenha
            if (paisDefault && pais[1] == paisDefault) {
              this.mudouPais(paisDefault, selectbox.getAttribute("data-identificador-estado"), utilizadorEstadoJaPreenchido)
              option.setAttribute('selected', true)
            }

            option.innerHTML = pais[0]
            option.value = pais[1]
            optionGroup.append(option)
          }
        }
      }
    } catch (e) {
      console.error(e)
      window.notificarSentry(e);

      Swal.fire({
        title: I18n.t('mensagem_requisicao_falha_pais'),
        text: I18n.t('erro_entre_contato'),
        icon: 'error',
        showCancelButton: false,
        confirmButtonText: I18n.t('tentar_novamente'),
      }).then((result) => {
        location.reload()
      })
    }
  }

  async mudouPais(paisSigla, identificadorEstado, utilizadorEstadoJaPreenchido = null) {
    try {
      let selectEstados = document.querySelector(`[data-id="${identificadorEstado}"]`)

      if (!selectEstados) return;

      if (paisSigla) {
        const response = await axios.get(`${selectEstados.getAttribute('data-url-get-paises')}/${paisSigla}.json`)
        const estados = response.data.estados

        //deve haver novos estados para eu montar o select
        if (estados.length > 0) {
          // remover os antigos
          this.limparFilhos(selectEstados)

          //default
          var optionDefault = document.createElement('option')
          optionDefault.value = ''
          optionDefault.innerHTML = ""
          selectEstados.append(optionDefault)

          // adicionando novos
          estados.map((estado) => {
            let option = document.createElement('option')

            option.innerHTML = estado.nome
            option.value = estado.sigla

            //selecionando já existente
            if (utilizadorEstadoJaPreenchido && utilizadorEstadoJaPreenchido == estado.sigla) {
              option.setAttribute('selected', true)
            }

            selectEstados.append(option)
          })
        } else {
          console.error('Erro ao carregar estados no método mudouPais', response)
        }
      } else {
        this.limparFilhos(selectEstados)

        var optionDefault = document.createElement('option')
        optionDefault.value = ''
        optionDefault.innerHTML = "Selecione um país primeiro"
        selectEstados.append(optionDefault)
      }
    } catch (error) {
      console.error('Erro ao carregar estados no método mudouPais 2', error)
      Swal.fire({
        title: I18n.t('mensagem_requisicao_falha_estado'),
        text: I18n.t('erro_entre_contato'),
        icon: 'error',
        showCancelButton: false,
        confirmButtonText: I18n.t('tentar_novamente'),
      }).then((result) => {
        location.reload()
      })
    }
  }

  limparFilhos(pai) {
    if (pai.options.length <= 0) return;

    let i = pai.options.length - 1;

    for (i; i >= 0; i--) {
      pai.remove(i);
    }
  }

  verificarSeUtilizadorFoiPreenchido(target) {
    let targetJquery = $(target);
    const preenchido = target.value !== '';

    // verifica qual é o input
    if (target.classList.contains('utilizador_nome')) {
      // obtem o input irmao
      let irmaoJquery = targetJquery.parents('.row').find("input.utilizador_email");
      const irmaoPreenchido = irmaoJquery.val() !== '';

      let labelTituloIngresso = targetJquery.parents('.row').find("h3");

      this.aplicaEstiloNoTituloDoIngresso(preenchido && irmaoPreenchido, labelTituloIngresso)
    } else if (target.classList.contains('utilizador_email')) {
      // obtem o input irmao
      let irmaoJquery = targetJquery.parents('.row').find("input.utilizador_nome")
      const irmaoPreenchido = irmaoJquery.val() !== ''

      let labelTituloIngresso = targetJquery.parents('.row').find("h3")

      this.aplicaEstiloNoTituloDoIngresso(preenchido && irmaoPreenchido, labelTituloIngresso)
    }
  }

  aplicaEstiloNoTituloDoIngresso = (preenchido, elemento) => {
    if (preenchido) {
      elemento.addClass('marker-blue');
    } else {
      elemento.removeClass('marker-blue');
    }
  }

  // Ajustes para os Eventos de Cruzeiro
  _atualizarOpcoesDeDocumento = function () {
    $(".segurado_documento").each((index, select) => {
      select = $(select)
      let oldValue = select.val();
      const elementos = $('.passageiro_documento');
      let html;
      let found = false;
      elementos.each(function (index, element) {
        element = $(element);
        if (element.val() != "") {
          found = true;
          html += "<option value=\"" + element.val() + "\">" + element.val() + "</option>"
        }
      })
      let header;
      if (found) {
        header = "<option value=\"\">Selecione o documento de um Passageiro</option>"
      } else {
        header = "<option value=\"\">Preencha primeiro os dados dos Passageiros</option>"
      }
      select.html(header + html);
      select.val(oldValue);
    })
  }

  _atualizarOpcoesDeNome = function () {
    $(".segurado_nome").each((index, select) => {
      select = $(select)
      let oldValue = select.val();
      const elementos = $('.passageiro_nome');
      let html;
      let found = false;
      elementos.each(function (index, element) {
        element = $(element);
        if (element.val() != "") {
          found = true;
          html += "<option value=\"" + element.val() + "\">" + element.val() + "</option>"
        }
      })
      let header;
      if (found) {
        header = "<option value=\"\">Selecione o nome de um Passageiro</option>"
      } else {
        header = "<option value=\"\">Preencha primeiro os dados dos Passageiros</option>"
      }
      select.html(header + html);
      select.val(oldValue);
    })
  }

  _lidarComCollectionsVindasDoJS = () => {
    let container = this.divInputsUtilizadoresTarget;
    $(container).find(".passageiro_documento").each((index, element) => {
      element = $(element)
      element.on('change', this._atualizarOpcoesDeDocumento)
    })
    $(container).find(".passageiro_nome").each((index, element) => {
      element = $(element)
      element.on('change', this._atualizarOpcoesDeNome)
    })
    this._atualizarOpcoesDeDocumento();
    this._atualizarOpcoesDeNome();
  }

  verificarSugestaoEmail(event) {
    let email = event.currentTarget.value.split('@')

    limparSugestoesEmails(event.currentTarget);
    if (email[1]) {
      let result = fuse.search(email[1])

      if (result.length >= 1 && result[0].item != email[1]) {
        montarSugestao(email[0], result[0].item, event.currentTarget)
      }
    }
  }
}
